<template>
  <tr>
    <td><format-date v-bind:date="request.dateCreated"></format-date></td>
    <td><format-user-name v-bind:name="request.requestorName"></format-user-name></td>
    <td><router-link :to="{name: 'CompanyInvestment', params: {investmentId: request.investmentId}}">{{ request.investmentName }}</router-link></td>
    <td>{{request.message}}</td>
    <td>
      <div class="btn-group">
        <button v-on:click.stop class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          Actions
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" v-on:click="markCompleted">Mark Completed</a></li>
        </ul>
      </div>
    </td>
  </tr>
</template>

<script type="text/javascript">

	import {RequestDataApi} from "@/api/request_data_api";
	import FormatDate from '../utils/FormatDate'
	import FormatUserName from "@/views/utils/FormatUserName";

	export default {
		name: 'OutstandingRequest',
		inheritAttrs: false,
		emits: ['requestUpdated'],
		mixins: [],
		components: {
			FormatDate,
			FormatUserName
		},

		filters: {
		},

		provide: function() {
			return {
			}
		},

		inject: [],

		props: ['request'],

		computed: {
		},

		watch: {
		},

		created() {
		},

		mounted() {
		},

		methods: {
			markCompleted() {
				RequestDataApi.updateStatus(this.request.guid, 'COMPLETED')
						.then(response => {
							this.$emit('requestUpdated', this.request, response.data)
						})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../../styles/custom-variables';
	td {
		color: $red;
	}
</style>
